import { translateService } from '../service/TranslateService.ts';
import { getCurrentLang } from '../utils.ts';
import { Lang } from '../entities/Lang.ts';


class DesktopTemplate {

  getHtml (languages: Lang[]) {
    const currentLang = languages.find((item) => item.shortCode === this.getCurrentLang());
    const otherLangs = languages.filter((item) => item.shortCode !== this.getCurrentLang());

    return /* html */ `
      <div class="GoogleTranslate GoogleTranslate--desktop">
      	<div class="GoogleTranslate__active-item">
      		${currentLang.template.getHtml(currentLang.name, currentLang.shortCode, this.getCurrentLang())}
      		<svg class="GoogleTranslate__arrow" width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      			<path d="M1.5 1L4.5 4L7.5 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      		</svg>
      	</div>
      	<div class="GoogleTranslate__options">
      		${otherLangs.map((lang) => lang.template.getHtml(lang.name, lang.shortCode, this.getCurrentLang())).join('')}
      	</div>
      </div> 
    `;
  }

  afterTranslate (){}

  getCurrentLang () {
    return getCurrentLang() || translateService.params.siteLanguage;
  }

}

const desktopTemplate = new DesktopTemplate();

export {
  DesktopTemplate,
  desktopTemplate,
};
